import {getCurrentImageEnvConfig, getImageEnvironment, LOCAL, getVersion} from "../config/config";
import { isIOSCheck } from "./common";

/**
 * 检查浏览器是否支持WebP格式
 * @returns {boolean}
 */
export const isSupportWebp = () => {
    try {
        return document.createElement('canvas').toDataURL('image/webp', 0.5).indexOf('data:image/webp') === 0;
    } catch (err) {
        return false;
    }
};

/**
 * 获取WebP支持状态（带缓存）
 * @returns {boolean}
 */
export const getAllowWebp = () => {
    const allowWebpStorage = localStorage.getItem('allowWebp');
    if (allowWebpStorage === 'true') {
        return true;
    } else if (allowWebpStorage === 'false') {
        return false;
    }
    const isSupport = isSupportWebp();
    if (isSupport) {
        localStorage.setItem('allowWebp', 'true');
        return true;
    }
    localStorage.setItem('allowWebp', 'false');
    return false;
};

/**
 * 生成图片处理URL
 * @param {string} formatUrl - 转换后的图片路径
 * @param {object} options - 选项
 * @param {number} options.width - 宽度
 * @param {number} options.height - 高度
 * @param {number} options.quality - 质量
 * @param {number} options.formatSize - 格式大小
 * @returns {string} - 处理后的URL
 */
export const generateProcessedImageUrl = (formatUrl, options = {}) => {
    const { width, height, quality, formatSize = 1 } = options;
    const imageEnvironment = getImageEnvironment();
    const imageEnvConfig = getCurrentImageEnvConfig();
    const supWebp = getAllowWebp();
    
    const imageProcess = imageEnvConfig.imageProcess;
    const baseUrl = imageEnvironment === LOCAL ? window.location.origin : imageEnvConfig.imageBaseUrl;
    const sitePath = imageEnvConfig.sitePath || '';
    
    let processedUrl = `${baseUrl}/${imageProcess.prefix}${sitePath}/${getVersion()}${formatUrl}?x-oss-process=image/format,${imageProcess.format}`;
    
    // 添加尺寸处理
    if (processedUrl.indexOf('/resize') === -1) {
        if (width) {
            let s = 0;
            if (width > height) {
                s = width;
            } else {
                s = height;
            }
            if (isIOSCheck()) {
                s = s * 3;
            } 
            if (s) {
                processedUrl = `${processedUrl}/resize,s_${parseInt(s) * formatSize}`;
            }
            if (imageProcess.quality) {
                processedUrl = `${processedUrl}/quality,q_${imageProcess.quality}`;
            }
        }
    }

    // 添加版本号
    if (imageProcess.version) {
        processedUrl = `${processedUrl}&v=${imageProcess.version}`;
    }
    
    // 如果不支持WebP，转换为PNG
    if (!supWebp) {
        processedUrl = processedUrl.replace(/webp/g, 'png');
    }
    
    return processedUrl;
};

/**
 * 生成最终的图片URL
 * @param {string} src - 原始图片路径
 * @param {object} options - 选项
 * @returns {string} - 最终的图片URL
 */
export const generateImageUrl = (src, options = {}) => {
    const imageEnvironment = getImageEnvironment();
    
    // 检查是否需要图片处理 需要判断是否支持webp
    if (src.match(new RegExp(/\.(png|jpg|jpeg)/)) && imageEnvironment !== LOCAL) {
        return generateProcessedImageUrl(src, options);
    } else {
        // 开发环境或不需要处理的图片
        if (imageEnvironment === LOCAL) {
            return src.startsWith('http') ? src : `${window.location.origin}${src}`;
        } else {
            return src;
        }
    }
}; 
